import { Skeleton } from '@mui/material';
import Button from '@mui/material/Button';
import Collapse from '@mui/material/Collapse';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { useState } from 'react';
import { CatchUpInvoice } from '../../../types/catchUps';
import { PolicyInvoice2Response } from '../../../types/policy';
import { PremiumReportingInvoice } from '../../../types/premiumReports';
import {
	WRITE_OFF_INVOICE_MODAL__BODY_TEXT_TITLE,
	WRITE_OFF_INVOICE_MODAL__CANCEL,
	WRITE_OFF_INVOICE_MODAL__LOADING,
	WRITE_OFF_INVOICE_MODAL__SUBMIT,
	WRITE_OFF_INVOICE_MODAL__TITLE,
} from '../data/constants';

interface ReversePaymentModalProps {
	open: boolean;
	invoice: PolicyInvoice2Response | PremiumReportingInvoice | CatchUpInvoice;
	handleClose: () => void;
	callback: (invoiceLocator: string, policyLocator: string) => Promise<void>;
	isCatchUp?: boolean;
}

const WriteOffPaymentModal = (props: ReversePaymentModalProps) => {
	const [formWizard, setFormWizard] = useState<
		'initial' | 'loading' | 'error' | 'success'
	>('initial');
	const { open, handleClose, invoice, callback, isCatchUp } = props;

	return (
		<Dialog open={open} onClose={handleClose}>
			<Collapse in={formWizard === 'initial'}>
				<DialogTitle>{WRITE_OFF_INVOICE_MODAL__TITLE(isCatchUp)}</DialogTitle>
				<DialogContent>
					{WRITE_OFF_INVOICE_MODAL__BODY_TEXT_TITLE(
						invoice.displayId,
						isCatchUp,
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={handleClose} color='neutralButton'>
						{WRITE_OFF_INVOICE_MODAL__CANCEL}
					</Button>
					<Button
						onClick={async () => {
							setFormWizard('loading');
							await callback(invoice.locator, invoice.policyLocator);
							handleClose();
						}}
						autoFocus
						color='primary'
						variant='contained'
					>
						{WRITE_OFF_INVOICE_MODAL__SUBMIT(isCatchUp)}
					</Button>
				</DialogActions>
			</Collapse>
			<Collapse in={formWizard === 'loading'}>
				<DialogTitle>{WRITE_OFF_INVOICE_MODAL__LOADING(isCatchUp)}</DialogTitle>
				<DialogContent>
					<DialogContentText>
						<Skeleton variant='text' />
					</DialogContentText>
				</DialogContent>
			</Collapse>
		</Dialog>
	);
};

export default WriteOffPaymentModal;
